import classNames from 'classnames'
import type { FunctionComponent } from 'react'
import { useRef } from 'react'

import styles from './expanding-plus-button.module.scss'

export const ExpandingPlusButton: FunctionComponent<Props> = ({
    width = 18,
    height = 18,
    open,
    onClick,
    className,
}) => {
    const buttonRef = useRef<HTMLButtonElement | null>(null)

    return (
        <button
            ref={buttonRef}
            aria-expanded={open}
            className={classNames(styles.button, className)}
            onClick={onClick}
        >
            {open ? (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={width}
                    height={height}
                    viewBox='0 0 19 3'
                    fill='none'
                    className='minus-icon'
                >
                    <path
                        d='M18.5879 1.2561L0.587891 1.25611'
                        stroke='white'
                        strokeWidth='2'
                    />
                </svg>
            ) : (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={width}
                    height={height}
                    viewBox='0 0 19 19'
                    fill='none'
                    className='plus-icon'
                >
                    <path
                        d='M18.041 9.69409L0.0410148 9.69409M9.04101 0.69409L9.04102 18.6941'
                        stroke='white'
                        strokeWidth='2'
                    />
                </svg>
            )}
        </button>
    )
}

interface Props {
    height?: number
    open: boolean
    onClick: (e: React.MouseEvent) => void
    className?: string
    width?: number
}
